export default "__VITE_ASSET__Docs8D_0__"